import { keepPreviousData, useQuery } from '@tanstack/react-query';

import { api } from '../../../core/network/api';
import { donorKeys } from '../queries/keys';
import { donorPaths } from '../queries/paths';

// TSS vite/03 — server-state hooks for cowhousing (donadoras co-poseídas).
// Endpoint REAL (contract: public-client-channel.md, GET public/donors) — NO
// provisional; la decisión 0001 no aplica porque hay api-reference. Cache /
// dedup / retry is TanStack Query's job; this module only declares keys+fetchers.
//
// GET public/donors?view=summary|full → sobre público (queries/types.js):
//   { schema_version, view, generated_at,
//     data: { items: DonorListItem[], pagination }, available_modules }
// El hook devuelve el sobre TAL CUAL — intencional: la UI futura lee
// data.items y available_modules, y pina schema_version.
// El scope por client_id sale del token server-side — nunca se envía desde acá.

/**
 * @param {{ view?: 'summary'|'full', limit?: number, offset?: number }} [filters]
 *   view=summary (default): identidad + económicos, sin stats (grilla barata).
 *   view=full: + stats { production, funnel, rates, offspring:{count} } por donadora.
 */
export function useClientDonors({ view = 'summary', limit, offset } = {}) {
    return useQuery({
        queryKey: donorKeys.list({ view, limit, offset }),
        queryFn: ({ signal }) =>
            api.get(donorPaths.list(), { params: { view, limit, offset }, signal }).then(r => r.data),
        // Keep the current page on screen while the next page loads.
        placeholderData: keepPreviousData,
    });
}
